// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__72135","notes":"Notes_notes__cqyhN"};